import styled, { css } from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { defaultSettings } from '../../../constants';
import { useChannels } from '../../channels';
import { useChat } from '../../chat';
import { getInvertedColor } from '../../helpers';
import { ChatButton } from './ChatButton';

export const AllInOneButton = () => {
  const {
    targetChatButton: { appTitle }
  } = useChat();
  const { buttonText, chatWallpaper = defaultSettings.chatWallpaper } =
    useSettings();
  const channels = useChannels();
  const titleColor = getInvertedColor({ color: chatWallpaper || '#000' });

  return (
    <Component _message={!!appTitle}>
      {!!buttonText && <Title _color={titleColor}>{buttonText}</Title>}

      <Buttons _buttonsLength={channels.length}>
        {channels.map((channel, index) => (
          <ChatButton key={channel?.link?.url ?? index} {...channel} />
        ))}
      </Buttons>
    </Component>
  );
};

const Component = styled.div<{ _message: boolean }>`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: ${({ _message }) => (_message ? '20px 20px 0 20px' : '20px')};
`;

const Buttons = styled.div<{ _buttonsLength: number }>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  ${({ _buttonsLength }) => css`
    flex-wrap: ${_buttonsLength > 6 ? 'wrap' : 'nowrap'};
    gap: 6px;
  `}
`;

const Title = styled.div<{ _color?: string }>`
  text-align: center;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 700;

  color: ${({ _color }) => _color};
`;
